import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { useTranslation } from 'react-i18next';
import { theme } from './chartTheme';

const PassesChart = ({ data, max }) => {
  const [t] = useTranslation();
  const tickValues = (data[0] && data[0].data.map(({ x }) => x)) || 'every 24 hours';
  return (
    <ResponsiveLine
      curve="monotoneX"
      margin={{ top: 5, right: 20, bottom: 35, left: 40 }}
      data={data}
      xScale={{
        type: 'time',
        format: 'native',
        precision: 'day',
      }}
      yScale={{
        type: 'linear',
        stacked: false,
        min: 0,
        max,
      }}
      axisLeft={{
        format: count => t('{{count, number_abbr}}', { count }),
      }}
      axisBottom={{
        format: '%d.%m',
        tickValues,
        tickSize: 11,
      }}
      enablePoints={false}
      enablePointLabel={false}
      pointSize={15}
      pointBorderWidth={2}
      pointBorderColor={{ from: 'color' }}
      colors={{ datum: 'color' }}
      lineWidth={2}
      useMesh={true}
      enableSlices="x"
      enableCrosshair={true}
      enableGridX={false}
      theme={theme}
    />
  );
};

export default PassesChart;
